import React, { useState } from 'react';
import { ShieldCheck } from 'lucide-react';
import { Boton } from './ui/Boton';
import { Casilla } from './ui/Campo';
import { TEXTO_ACEPTACION } from '../data/textos';
export function Bienvenida({
  onAceptar
}: {
  onAceptar: () => void;
}) {
  const [aceptado, setAceptado] = useState(false);
  const [error, setError] = useState('');
  return <div className="flex min-h-screen w-full items-center justify-center bg-lienzo px-4 py-10" data-id="element-322" data-mp="1qk66n4hpp845">
      <main className="w-full max-w-xl" data-id="element-323" data-mp="1vj9cgr5inid6">
        <div className="rounded-2xl border border-linea bg-white p-6 shadow-[0_1px_3px_rgba(17,24,39,0.06)] sm:p-8" data-id="element-324" data-mp="20jwyszisvb12">
          <div className="mb-5 flex items-center gap-3" data-id="element-325" data-mp="25c81ub8u7cxu">
            <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-vino-oscuro text-sm font-extrabold text-white" aria-hidden="true" data-id="element-326" data-mp="29cqu26en6l0k">
              PP
            </span>
            <div data-id="element-327" data-mp="2ja50rearjvfo">
              <p className="text-sm font-extrabold text-vino" data-id="element-328" data-mp="2jbpvp50zpge2">Planificador Pro</p>
              <p className="text-xs text-tinta-tenue" data-id="element-329" data-mp="12ikbgt1x3xa3">Clases de telas</p>
            </div>
          </div>

          <h1 className="text-2xl font-extrabold text-tinta-titulo sm:text-3xl" data-id="element-330" data-mp="xi61v6ko4f9y">
            Planificá con claridad. Enseñá con criterio.
          </h1>
          <p className="mt-3 text-sm text-tinta-sec" data-id="element-331" data-mp="tjgqfjj6x7sy">
            Esta herramienta te ayuda a organizar objetivos, tiempos, ejercicios y adaptaciones para
            cada grupo.
          </p>

          <div className="mt-6 rounded-xl border border-vino/20 bg-vino/5 p-4" data-id="element-332" data-mp="1lamn1pzpcndh">
            <div className="mb-2 flex items-center gap-2 text-sm font-semibold text-vino" data-id="element-333" data-mp="1h7zzw2dz7qmm">
              <ShieldCheck className="h-4 w-4" aria-hidden="true" data-id="element-334" data-mp="1cex2fj62vx15" />
              Alcance de la herramienta
            </div>
            <Casilla etiqueta={TEXTO_ACEPTACION} checked={aceptado} onChange={setAceptado} data-id="element-335" data-mp="17fkib66ld429" />
          </div>

          {error && <p role="alert" className="mt-3 text-sm font-semibold text-alerta" data-id="element-336" data-mp="205j4mttein38">
              {error}
            </p>}

          <Boton className="mt-6 w-full" onClick={() => {
          if (!aceptado) {
            setError('Necesitás marcar la casilla para continuar.');
            return;
          }
          onAceptar();
        }} data-id="element-337" data-mp="2j3mbl0058j9w">
            Ingresar al planificador
          </Boton>
          <p className="mt-3 text-center text-xs text-tinta-tenue" data-id="element-338" data-mp="2e988ebf8p7uo">
            La aceptación se guarda en este dispositivo y podés consultarla desde Ayuda y seguridad.
          </p>
        </div>
      </main>
    </div>;
}